module.exports = __webpack_public_path__ + "Roboto-Thin.3f68500b267c20051088.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-Thin.ttf
// module id = 389
// module chunks = 2